module.exports = __webpack_public_path__ + "img/logo2.a6b08b18.png";